export const baseUrl = {
  address: window._env_?.VITE_BASE_API_URL || import.meta.env.VITE_BASE_API_URL,
  base: window._env_?.VITE_BASE_API_URL || import.meta.env.VITE_BASE_API_URL,
};
